import { Component, Input } from '@angular/core';
import { QueryService } from '../../comun/services/query.service';
import { GlobalConstants } from '../../global-constants';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-header-menu-mini',
  templateUrl: './header-menu-mini.component.html',
  styleUrl: './header-menu-mini.component.css'
})
export class HeaderMenuMiniComponent {
  @Input() misdatos: any = {};
  @Input() busy: boolean = true;
  @Input() isScrolled: any = {};

  constructor(private query: QueryService) {}

  logout() {
    Swal.fire({
      title: 'Confirmación',
      text: '¿Te desconectamos o te quedas otro ratito?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Me quedo',
      cancelButtonText: 'Sí',
      customClass: {
        confirmButton: 'custom-swal-confirm',
        //cancelButton: 'custom-swal-cancel'
      },
    }).then((result) => {
      if (result.isConfirmed) {
      }
      if (result.isDismissed && result.dismiss === Swal.DismissReason.cancel) {
        // Usuario offline
        this.query.query('misdatos', 'ONLINE', { online: ''}).subscribe((resultado:any) => {
        });
        // Chat offline
        this.query.query('mensajes', 'CHATONLINE', { chatonline: ''}).subscribe((resultado:any) => {
        });
        this.query.query('misdatos', 'LOGOUT', null).subscribe((resultado:any) => {
          window.location.href = GlobalConstants.urlServer;
        });
      }
    });
  }

}
